import Routers from "./Components/Route/Routers";
import ConfigSWR from "./Services/Swr";
//import 'bootstrap/dist/js/bootstrap.bundle.min.js';

function App() {
  return (
    <div className="App">
      <ConfigSWR>
        <Routers />
      </ConfigSWR>
    </div>
  );
}

export default App;
